module.exports = __webpack_public_path__ + "img/memory-game.c0e00938.png";